"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        fontSize: 16,
        color: theme.grey4,
        '&[data-is-error=true]': {
            color: 'red'
        }
    }
});
//# sourceMappingURL=numericWidget.style.js.map